import * as React from 'react';
import { useRef,  } from 'react'
import {gold, white, black, fontBrand } from '../../../../getLPTheme';
import 'react-multi-carousel/lib/styles.css';
import { Stack, } from "@mui/material";
import Container from '@mui/material/Container';
import { Box, } from "@mui/material";
import CarouselesContainer from './CarouselesContainer'


export default function CarouselContent () {

  const valueRef = useRef('') //creating a refernce for TextField Component

  const sendValue = () => {
      return console.log(valueRef.current.valueOf) //on clicking button accesing current value of TextField and outputing it to console 
  }

  return (
    <Box>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 5, sm: 5 },
        }}
      >
        <Stack spacing={2} useFlexGap sx={{ width: { xs: '100%', sm: '70%' } }}>
          <Box sx={{width:"100%", display: "flex",  flexDirection: 'row', alignItems: "Center", justifyContent: "center" }}>
          </Box>
          <Box sx={{display: 'flex',flexDirection: 'column',alignSelf: 'center',textAlign: 'center',}}>
            <CarouselesContainer/>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}